import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { RenderDatePicker, RenderCheckboxRadioField, RenderSubmitButton } from '../../common/form';
import * as Validations from '../../common/form/commonValidations';
import { editChecklist, fetchTemplates } from '../../../actions/ChecklistActions';
import { hideModal } from '../../../actions/ModalActions';
import { fetchWedding } from '../../../actions/WeddingActions';

class EditChecklistForm extends Component {

  constructor(props) {
    super(props);

    this.toggleTemplate = this.toggleTemplate.bind(this);
  }

  componentDidMount() {
    const { getTemplates } = this.props;
    getTemplates();
  }

  toggleTemplate(event, templateId, level, multiple = false) {
    const { selectedTemplateIds, onUpdateTemplateIds, templates } = this.props;
    const index = selectedTemplateIds.indexOf(templateId);

    if (index < 0) { // wasn't selected
      if (event.target.checked) { // was checked
        const copy = [...selectedTemplateIds];
        if (!multiple) {
          _.pullAll(copy, templates.levelToId[level]);
        }
        copy.push(templateId);
        onUpdateTemplateIds(change('EditChecklistForm', 'checklist_template_ids', copy));
      }
    } else if (index >= 0) {
      if (!event.target.checked) { // was unchecked
        const copy = [...selectedTemplateIds]; // make copy to not mutate value
        copy.splice(index, 1); // remove item at index
        onUpdateTemplateIds(change('EditChecklistForm', 'checklist_template_ids', copy));
      }
    }
  }

  render() {
    const { handleSubmit, pristine, submitting, valid, templates, selectedTemplateIds } = this.props;

    return (
      <div>
        <div className="modal-header">
          <h3 className="modal-title">Checklist Settings</h3>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <Field
                  name="wedding_date"
                  type="date"
                  id="eventDate"
                  component={RenderDatePicker}
                  required
                  placeholder="MM/DD/YYYY"
                  validate={[Validations.REQUIRED, Validations.DATE, Validations.DATE_WITHIN_VALID_RANGE]}
                  label="Wedding Date"
                />
              </div>
            </div>
            <div className="form-group">
              <h4>How Much Guidance Would You Like?</h4>
              <Field
                id="checklist-detailed-false"
                name="is_detailed"
                component={RenderCheckboxRadioField}
                type="radio"
                label="A Little Guidance"
                // validate={Validations.REQUIRED}
                styleOverride
                value="false"
                inline
              />
              <Field
                id="checklist-detailed-true"
                name="is_detailed"
                component={RenderCheckboxRadioField}
                // checked={checklist.isDetailed}
                type="radio"
                label="A Lot Of Guidance"
                // validate={Validations.REQUIRED}
                styleOverride
                value="true"
                inline
              />
            </div>
            <div className="form-group">
              <h4>Are Most Guests Traveling To Your Wedding?</h4>
              {templates.levelToId[1] && templates.levelToId[1].map(templateId => (
                <Field
                  key={templateId}
                  id={`template-id-${templateId}`}
                  name="temp_checklist_template_ids[1]"
                  component={RenderCheckboxRadioField}
                  type="radio"
                  label={templates.byId[templateId].title}
                  // validate={Validations.REQUIRED}
                  styleOverride
                  inline
                  value={`${templateId}`}
                  checkedOverride
                  checked={selectedTemplateIds.indexOf(templateId) >= 0}
                  onChange={e => this.toggleTemplate(e, templateId, 1, false)}
                />
              ))}
            </div>
            <div className="form-group">
              <h4>Are You Including Any Cultural Or Religious Traditions In Your Ceremony?</h4>
              <div className="row">
                {templates.levelToId[2] && templates.levelToId[2].map(templateId => (
                  <div key={templateId} className="col-xs-12 col-md-6">
                    <Field
                      id={`template-id-${templateId}`}
                      name={`temp_checklist_template_ids[2][${templateId}]`}
                      component={RenderCheckboxRadioField}
                      type="checkbox"
                      label={templates.byId[templateId].title}
                      styleOverride
                      value={`${templateId}`}
                      checkedOverride
                      checked={selectedTemplateIds.indexOf(templateId) >= 0}
                      onChange={e => this.toggleTemplate(e, templateId, 2, true)}
                    />
                  </div>
                ))}
              </div>
            </div>
            <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} />
          </form>
        </div>
      </div>
    );
  }
}

EditChecklistForm.propTypes = {
  getTemplates: PropTypes.func.isRequired,
  onUpdateTemplateIds: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  templates: PropTypes.shape({}),
  selectedTemplateIds: PropTypes.arrayOf(PropTypes.number)
};

const selector = formValueSelector('EditChecklistForm');

const mapStateToProps = state => ({
  initialValues: {
    is_detailed: state.checklist.checklist.isDetailed ? 'true' : 'false',
    checklist_template_ids: state.checklist.checklist.templateIds,
    wedding_date: state.wedding.wedding.wedding_date ? moment.utc(state.wedding.wedding.wedding_date) : undefined
  },
  templates: state.checklist.templates,
  selectedTemplateIds: selector(state, 'checklist_template_ids') || []
});

const mapDispatchToProps = dispatch => ({
  getTemplates: () => dispatch(fetchTemplates()),
  onSubmit: (editChecklistRequest) => {
    // TODO: Error handling
    dispatch(editChecklist(editChecklistRequest)).then(() => dispatch(fetchWedding()));
    dispatch(hideModal());
  },
  onUpdateTemplateIds: input => dispatch(input)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'EditChecklistForm',
  enableReinitialize: true
})(EditChecklistForm));



// WEBPACK FOOTER //
// ./src/components/manage/checklist/EditChecklistForm.jsx